module.exports = __webpack_public_path__ + "img/Logo_RUTUBE_white_mono.b9b579d9.svg";